import React, { useEffect } from "react";

import { useHistory } from "react-router-dom";
import Footer from "../footer";
import { useDispatch } from "react-redux";
import { setActivePage } from "../../redux/actions/appSettingsActions";
import { Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  sectionMobile: {
    display: "block",
    marginTop: 100,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

function HomePage() {
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();
  const NavigateMap = (page) => {
    dispatch(setActivePage(page));
    history.push("/" + page);
  };
  useEffect(() => {
    dispatch(setActivePage("Home"));
  }, []);

  return (
    <>
      <section id="hero" className="bgcover">
        <div className={classes.sectionDesktop}>
          <div className="d-block w-80">
            <div className="adressingjss356">
              <Typography className="adressingjss358" variant="h3">
                Welcome to RAK MAPS
              </Typography>
              <Typography className="adressingjss359" variant="h6">
                <span>
                  <p>Bring your solutions to life with GIS data and APIs..</p>
                  <p>
                    Get started and benefit from the power of location by Ras al
                    khaimah municipality's GIS Centre most comprehensive GIS
                    Solutions into your finger tips.
                  </p>
                </span>
              </Typography>
              <div className="adressingjss360">
                <Button
                  variant="contained"
                  color="primary"
                  className="adressingjss348"
                  onClick={() => NavigateMap("Map")}
                >
                  Launch RAK MAP
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  className="adressingjss348 contact-btn"
                  onClick={() => NavigateMap("Contact")}
                >
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.sectionMobile}>
          <div className="container">
            <div className="row">
              <div className="col-xl-6">
                <Typography variant="h3">Welcome to RAK MAPS</Typography>
                <Typography variant="h6">
                  <span>
                    <p>Bring your solutions to life with GIS data and APIs..</p>
                  </span>
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className="adressingjss348"
                  onClick={() => NavigateMap("Map")}
                >
                  Launch RAK MAP
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default HomePage;
